import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { useAuthStore } from './AuthStore';

import SignIn from './SignIn';

type Props = unknown;

export const AuthProtected: React.FC<Props> = ({ children }) => {
  const store = useAuthStore();
  return (
    store.isAuthenticated ? <>{children}</> : <SignIn />
  );
}

AuthProtected.propTypes = {
  children: PropTypes.element,
};

export default observer(AuthProtected);
